import { render, staticRenderFns } from "./MomentSquareComponent.vue?vue&type=template&id=6760a0f4&scoped=true&"
import script from "./MomentSquareComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentSquareComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentSquareComponent.vue?vue&type=style&index=0&id=6760a0f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6760a0f4",
  null
  
)

export default component.exports